import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { ImgHTMLAttributes } from 'react';

interface IProps extends ImgHTMLAttributes<any> {
	placeholderStyle?: React.CSSProperties;
	iconSize?: '1x' | '2x' | '3x' | '4x' | '5x' | 'sm';
}

const ImageWithFallback2 = ({ placeholderStyle, iconSize, ...rest }: IProps) => {
	const [hasError, setError] = useState(false);
	const onError = () => {
		setError(true);
	};

	if (hasError) {
		return (
			<div
				className="d-flex justify-content-center align-items-center"
				style={placeholderStyle}
			>
				<FontAwesomeIcon size={iconSize ?? '3x'} icon={faCamera} color="white" />
			</div>
		);
	}

	return <img {...rest} onError={onError} />;
};

export default ImageWithFallback2;
